import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * The headline for the about page
 */
const Headline = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box
      sx={{
        position: 'relative',
        marginY: isMd ? '8em' : '3em',
        '&::after': {
          position: 'absolute',
          content: '""',
          width: '30%',
          zIndex: 1,
          top: 0,
          left: 0,
          height: '100%',
          backgroundSize: '18px 18px',
          backgroundImage: (theme) =>
            `radial-gradient(${theme.palette.primary.dark} 20%, transparent 20%)`,
          opacity: 0.2,
        },
      }}
    >
      <Box position="relative" zIndex={2}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color="textSecondary"
          component="h1"
          align="center"
        >
          About us
        </Typography>
        <Box marginBottom={2}>
          <Typography
            variant="h2"
            align="center"
            sx={{
              fontWeight: 700,
            }}
          >
            Critical training to keep your people safe
          </Typography>
        </Box>
        <Box marginBottom={4}>
          <Typography variant="h6" align="center">
            Our expert-led, realistic programs deliver the confidence and
            preparedness your organization needs to respond effectively to
            real-world threats
          </Typography>
        </Box>
        <Box display="flex" justifyContent={'center'}>
          <Button
            component={Link}
            to="/purchase-training"
            variant="contained"
            color="primary"
            size="large"
            endIcon={<ChevronRightRoundedIcon />}
          >
            Start Training Now
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Headline;
